<template>
    <v-app id="inspire">
        <div class="productivity-report-show-wrap">
            <v-layout class="inv-top-header mb-4">
              <v-flex>
                <p class="text-uppercase caption mb-0">Productivity Report/Individual Report</p>
                <template v-if="!loading && !loadingProductivityReport">
                  <h2 class="headline" v-if="!no_data.includes(employee)">{{employee.first_name}}, {{employee.last_name}}</h2>
                </template>
                <v-skeleton-loader
                  v-else
                  class="mt-2"
                  type="heading"
                ></v-skeleton-loader>
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn class="header-btn-back mr-0 mb-3 mt-0" @click="$router.go(-1)">
                <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                Back
              </v-btn>
            </v-layout>

            <v-tabs
              v-model="active"
              slider-color="primary"
              show-arrows
            >
              <v-tab 
                ripple 
              >
                <v-icon>attach_money</v-icon> Revenue
              </v-tab>
              <v-tab 
                ripple 
              >
                <v-icon class="mr-2">announcement</v-icon> Complaints
              </v-tab>
              <v-tab-item style="padding: 0 2px 3px;">
                <v-divider></v-divider>
                <v-card class="mt-6 pa-4">
                  <h3>Revenue per Hour</h3>
                  <v-container class="grid-list-lg px-0">
                    <v-layout class="wrap xs12 px-0">
                      <div class="text-right mt-2 mr-6">
                        <div class="px-2 py-1" style="border-right: solid 2px #16e4e6;">
                          <div class="grey--text">Previous Period</div>  
                          <div class="title" style="min-height: 20px;">
                              <template v-if="all_items !== null && !no_data.includes(all_items.revenue_per_hour_previous_week)">
                                <span class="body-1 grey--text">$</span>{{all_items.revenue_per_hour_previous_week}}
                              </template>
                              <span v-else class="grey--text caption">No Data</span>
                          </div>  
                        </div>
                      </div>
                      <div class="text-right mt-2 mr-6">
                        <div class="px-2 py-1" style="border-right: solid 2px #4caf50;">
                          <div class="grey--text">Period of 
                            <template v-if="all_items !== null">{{ titleDateFormat() }}</template>
                          </div>  
                          <div class="title" style="min-height: 20px;">
                              <template v-if="all_items !== null && !no_data.includes(all_items.revenue_per_hour_current_week)">
                                <span class="body-1 grey--text">$</span>{{all_items.revenue_per_hour_current_week}}
                              </template>
                              <span v-else class="grey--text caption">No Data</span>
                          </div>  
                        </div>
                      </div>
                      <div class="text-right mt-2 mr-6">
                        <div class="px-2 py-1" style="border-right: solid 2px #ff5252;">
                          <div class="grey--text">Minimum</div>  
                          <div class="title" style="min-height: 20px;">
                              <template v-if="employee !== null && !no_data.includes(employee.min_revenue_per_hour)">
                                <span class="body-1 grey--text">$</span>{{employee.min_revenue_per_hour}}
                              </template>
                              <span v-else class="grey--text caption">No Data</span> 
                          </div>  
                        </div>
                      </div>
                    </v-layout>
                  </v-container>
                </v-card>

                <v-card v-if="!showCharts && chartsLoaded" class="mt-6 pa-4">
                  <h3 class="mb-4">Trends for Past 3 Months</h3>
                  <line-example :chart-data="RevenuePerHour"></line-example>
                </v-card>

                <v-card class="mt-6 pa-4">
                  <h3>Revenue per Mile</h3>
                  <v-container class="grid-list-lg px-0">
                    <v-layout class="wrap xs12 px-0">
                      <div class="text-right mt-2 mr-6">
                        <div class="px-2 py-1" style="border-right: solid 2px #ffeb3c;">
                          <div class="grey--text">Previous Period</div>  
                          <div class="title" style="min-height: 20px;">
                              <template v-if="all_items !== null && !no_data.includes(all_items.revenue_per_mile_previous_week)">
                                <span class="body-1 grey--text">$</span>{{all_items.revenue_per_mile_previous_week}}
                              </template>
                              <span v-else class="grey--text caption">No Data</span> 
                          </div>  
                        </div>
                      </div>
                      <div class="text-right mt-2 mr-6">
                        <div class="px-2 py-1" style="border-right: solid 2px #00838F;">
                          <div class="grey--text">Period of
                            <template v-if="all_items !== null">{{ titleDateFormat() }}</template>  
                          </div>  
                          <div class="title" style="min-height: 20px;">
                              <template v-if="all_items !== null && !no_data.includes(all_items.revenue_per_mile_current_week)">
                                <span class="body-1 grey--text">$</span>{{all_items.revenue_per_mile_current_week}}
                              </template>
                              <span v-else class="grey--text caption">No Data</span>   
                          </div>  
                        </div>
                      </div>
                      <div class="text-right mt-2 mr-6">
                        <div class="px-2 py-1" style="border-right: solid 2px #ff5252;">
                          <div class="grey--text">Minimum</div>  
                          <div class="title" style="min-height: 20px;">
                              <template v-if="employee !== null && !no_data.includes(employee.min_revenue_per_mile)">
                                <span class="body-1 grey--text">$</span>{{employee.min_revenue_per_mile}}
                              </template>
                              <span v-else class="grey--text caption">No Data</span>
                          </div>  
                        </div>
                      </div>
                    </v-layout>
                  </v-container>
                </v-card>

                <v-card v-if="!showCharts && chartsLoaded" class="mt-6 mb-12 pa-4">
                  <h3 class="mb-4">Trends for Past 3 Months</h3> <!-- Average Revenue / Mile -->
                  <line-example :chart-data="RevenuePerMile"></line-example>
                </v-card>
              </v-tab-item>

              <v-tab-item style="padding: 0 2px 3px;">
                <v-divider></v-divider>
                <h3 class="mt-6">Complaints per Job</h3>

                <v-container class="grid-list-lg px-0">
                  <v-layout class="wrap justify-end xs12 px-0">
                    <v-flex class="sm12 md6">
                      <v-card class="pa-4">
                        <h3>Previous Pay Period</h3>
                        <v-container class="grid-list-lg px-0">
                          <v-layout class="wrap xs12 px-0">
                            <div class="text-right mt-2 mr-6">
                              <div class="px-2 py-1" style="border-right: solid 2px #16e4e6;">
                                <div class="grey--text">Complaints</div>  
                                <div class="title" style="min-height: 20px;">
                                    <template v-if="all_items !== null && !no_data.includes(all_items.count_complaints_last_week)">
                                      <span class="body-1 grey--text">#</span>{{all_items.count_complaints_last_week}}
                                    </template>
                                    <span v-else class="grey--text caption">No Data</span>
                                </div>  
                              </div>
                            </div>
                            <div class="text-right mt-2 mr-6">
                              <div class="px-2 py-1" style="border-right: solid 2px #4caf50;">
                                <div class="grey--text">Jobs</div>  
                                <div class="title" style="min-height: 20px;">
                                    <template v-if="all_items !== null && !no_data.includes(all_items.count_jobs_last_week)">
                                      <span class="body-1 grey--text">#</span>{{all_items.count_jobs_last_week}}
                                    </template>
                                    <span v-else class="grey--text caption">No Data</span>
                                </div>  
                              </div>
                            </div>
                            <div class="text-right mt-2 mr-6">
                              <div class="px-2 py-1" style="border-right: solid 2px #ff5252;">
                                <div class="grey--text">Ratio</div>  
                                <div class="title" style="min-height: 20px;">
                                    <template v-if="all_items !== null && !no_data.includes(all_items.count_complaints_last_week) && !no_data.includes(all_items.count_jobs_last_week)">
                                      <template v-if="parseFloat(all_items.count_complaints_last_week) !== 0 && parseFloat(all_items.count_jobs_last_week) !== 0">
                                      {{(parseFloat(all_items.count_complaints_last_week) / parseFloat(all_items.count_jobs_last_week) * 100).toFixed(2)}}<span class="body-1 grey--text">%</span>
                                      </template>
                                      <template v-else>0.00<span class="body-1 grey--text">%</span></template>
                                    </template>
                                    <span v-else class="grey--text caption">No Data</span>
                                </div>  
                              </div>
                            </div>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-flex>

                    <v-flex class="sm12 md6">
                      <v-card class="pa-4">
                        <h3>3 Months Average</h3>
                        <v-container class="grid-list-lg px-0">
                          <v-layout class="wrap xs12 px-0">
                            <div class="text-right mt-2 mr-6">
                              <div class="px-2 py-1" style="border-right: solid 2px #ffeb3c;">
                                <div class="grey--text">Complaints</div>  
                                <div class="title" style="min-height: 20px;">
                                    <template v-if="all_items !== null && !no_data.includes(all_items.average_complaints_three_months)">
                                      <span class="body-1 grey--text">#</span>{{parseFloat(all_items.average_complaints_three_months).toFixed(2)}}
                                    </template>
                                    <span v-else class="grey--text caption">No Data</span>
                                </div>  
                              </div>
                            </div>
                            <div class="text-right mt-2 mr-6">
                              <div class="px-2 py-1" style="border-right: solid 2px #00838F;">
                                <div class="grey--text">Jobs</div>  
                                <div class="title" style="min-height: 20px;">
                                    <template v-if="all_items !== null && !no_data.includes(all_items.average_jobs_three_months)">
                                      <span class="body-1 grey--text">#</span>{{parseFloat(all_items.average_jobs_three_months).toFixed(2)}}
                                    </template>
                                    <span v-else class="grey--text caption">No Data</span>  
                                </div>  
                              </div>
                            </div>
                            <div class="text-right mt-2 mr-6">
                              <div class="px-2 py-1" style="border-right: solid 2px #ff5252;">
                                <div class="grey--text">Ratio</div>  
                                <div class="title" style="min-height: 20px;">
                                    <template v-if="all_items !== null && !no_data.includes(all_items.average_complaints_three_months) && !no_data.includes(all_items.average_jobs_three_months)">
                                      <template v-if="parseFloat(all_items.average_complaints_three_months) !== 0 && parseFloat(all_items.average_jobs_three_months) !== 0">
                                        {{(parseFloat(all_items.average_complaints_three_months) / parseFloat(all_items.average_jobs_three_months) * 100).toFixed(2)}}<span class="body-1 grey--text">%</span>
                                      </template>
                                      <template v-else>0.00<span class="body-1 grey--text">%</span></template>
                                    </template>
                                    <span v-else class="grey--text caption">No Data</span>
                                </div>  
                              </div>
                            </div>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-flex>
                  </v-layout>

                  <v-card v-if="showCharts && chartsLoaded" class="xs12 mt-6 mb-12 pa-4">
                    <h3 class="mb-4">Complaints/Job Ratio (Trends for Past 3 Months)</h3>
                    <line-example :chart-data="Complaints"></line-example>
                  </v-card>
                </v-container>
              </v-tab-item>
            </v-tabs>
        </div>
    </v-app>
</template>

<script>
    import EventBus from '@/main'
    import ApiService from "@/common/api.service"
    import moment from "moment"
    import LineExample from '@/common/LineChart.js'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "ProductivityReportShow",
        components: {
          LineExample
        },
        data: () => ({
            weekStartEnd: [],
            menu1: false,
            no_data: [null, '', undefined, 'null'],
            items: [],
            loading: false,
            loadingProductivityReport: false,
            loadingOrganizationSettings: false,
            employee: null,
            all_items: null,
            active: 0,
            showCharts: false,
            chartsLoaded: false,
            chartData: null,
            RevenuePerHour: null,
            RevenuePerMile: null,
            Complaints: null
        }),
        mounted() {
          this.initialize()
        },
        methods: {
          ...mapActions(['checkOrganizationSettings']),
          initialize() {
            this.loading = true
            this.getOrganizationSettings()
              .then(() => {
                return this.getProductivityReport()
              })
              .then(() => {
                this.loading = false
              })
              .catch(error => {
                this.loading = false
              })
          },
          getProductivityReport() {
            this.loadingProductivityReport = true
            return new Promise((resolve, reject) => {
              let body = {
                staff_id: this.$route.params.id,
              }

              ApiService.get('/payroll/personal_report', body)
                .then(response => {
                  this.employee = response.data.employee
                  this.setWeekStartEnd(response.data.date_from)
                  this.all_items = response.data
                  this.setChartData(response.data.revenue_per_hour_last_three_months, 
                                    response.data.revenue_per_mile_last_three_months,
                                    response.data.complaints_per_job_last_three_months)
                  this.chartsLoaded = true
                  this.loadingProductivityReport = false
                  resolve()
                })
                .catch(error => {
                  console.log(error);
                  this.loadingProductivityReport = false
                  reject()
                })
            })
          },
          getOrganizationSettings() {
            this.loadingOrganizationSettings = true;
            return new Promise((resolve, reject) => {
            this.checkOrganizationSettings()
              .then(response => {
                this.setWeekStartEnd()
                this.loadingOrganizationSettings = false;
                resolve()
              })
              .catch(error => {
                console.log(error);
                this.loadingOrganizationSettings = false;
                reject()
              });
            })
          },
          getIndex(array, key, value) {
              return array.findIndex(i => i[key] == value)
          },
          updateWeek (newDate) {
            const oldDate = this.weekStartEnd
            if (newDate.length < oldDate.length) {
              this.weekStartEnd = oldDate
              return
            }

            const selectedDate = newDate[newDate.length - 1]
            this.setWeekStartEnd(selectedDate)
            this.menu1 = false
          },
          setWeekStartEnd(selectedDate) {
            this.weekStartEnd = this.payPeriodDays(selectedDate);
          },
          titleDateFormat () {
            if(this.weekStartEnd.length) {
              return `${this.weekStartEnd[0]} - ${this.weekStartEnd[this.weekStartEnd.length - 1]}`
            } else {
              return ''
            }
          },
          setChartData(d1, d2, d3) {
            this.RevenuePerHour = {
              labels: d1.map(i => moment(i.date).format('MM[-]DD')),
              label1: 'Personal',
              data1: d1.map(i => i.personal_revenue),
              label2: 'Company',
              data2: d1.map(i => i.company_revenue),
              label3: 'Minimum',
              data3: d1.map(i => i.min_revenue)
            }
            this.RevenuePerMile = {
              labels: d2.map(i => moment(i.date).format('MM[-]DD')),
              label1: 'Personal',
              data1: d2.map(i => i.personal_revenue),
              label2: 'Company',
              data2: d2.map(i => i.company_revenue),
              label3: 'Minimum',
              data3: d2.map(i => i.min_revenue)
            }
            this.Complaints = {
              labels: d3.map(i => moment(i.date).format('MM[-]DD')),
              label1: 'Personal Ratio (%)',
              data1: d3.map(i => {
                if(parseFloat(i.personal_count_complaints) === 0 || parseFloat(i.personal_count_jobs) === 0) {
                  return 0
                } else {
                  return (parseFloat(i.personal_count_complaints) / parseFloat(i.personal_count_jobs) * 100).toFixed(2)
                }
              }),
              label2: 'Company Ratio (%)',
              data2: d3.map(i => {
                if(parseFloat(i.company_count_complaints) === 0 || parseFloat(i.company_count_jobs) === 0) {
                  return 0
                } else {
                  return (parseFloat(i.company_count_complaints) / parseFloat(i.company_count_jobs) * 100).toFixed(2)
                }
              }),
              label3: 'Maximum Ratio (%)',
              data3: null
            }
          }
        },
        computed: {
          ...mapGetters([
            'organizationSettings',
            'payPeriodDays'
          ])
        },
        watch: {
          active: function (newActive, oldActive) {
            if(newActive === 1) {
              setTimeout(() => {
                this.showCharts = true
              }, 100)
            } else if (newActive === 0) {
              setTimeout(() => {
                this.showCharts = false
              }, 100)
            }
          }
        }
    }
</script>
<style>

    /**tools table**/
    .productivity-report-show-wrap div.datatable.table {
        margin-bottom: 0%;
    }

    .productivity-report-show-wrap .header-search-single {
        padding-bottom: 0px;
    }

    /*Search field width*/
    .search-org {
        min-width: 120px;
    }

    td a {
        text-decoration: none;
    }

    .dialog-heading {
        background-color: #efefef;
        padding: 10px;
    }

    .no-opacity {
        opacity: 0;
    }

    .clear-filters {
        text-transform: none;
        color: #00838F;
        cursor: pointer;
        text-decoration: underline;
        font-size: 14px;
    }

    .productivity-report-show-wrap .table-head-text {
      white-space: normal; 
      text-align: left;
      min-width: 100px;
    }

    .table-org td.actions-position {
      position: absolute;
      right: 0;
      border-left: 1px solid rgba(0,0,0,0.12)!important;
      border-top: none!important;
      border-bottom: none!important;
      padding-top: 13px!important;
      padding-bottom: 13px!important;
      background: #fff;

      -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      will-change: background;
    }

    .table-org th.actions-position::before {
      content: "Actions";
      position: absolute;
      top: 0;
      right: 0;
      padding: 19px 24px;
      border-left: 1px solid rgba(0,0,0,0.12)!important;
      border-top: none!important;
      border-bottom: none!important;
      text-align: left;
      width: 109px;
      height: 56px;
      background: #fff;
    }

    .table-org th.actions-position {
        width: 108px!important;
    }

    .table-org tr:not(:nth-child(1)) td.actions-position {
      border-bottom: 1px solid rgba(0,0,0,0.12)!important;  
    }

    .table-org tr:hover td.actions-position {
      background: #e0f5f8;
    }

    .vertical-table-devider {
      border-left: 1px solid #00838F;
    }

    /*Invoice total section*/
    .inv-desc-total {
      text-align: right;
      font-size: 14px;
    }

    .inv-desc-amount-titles {
      display: inline-block;
      padding-right: 50px;
      font-size: 14px;
    }

    .inv-desc-amount-values {
      display: inline-block;
      text-align: left;
      width: 208px;
      padding: 24px;
    }

    .inv-edit-table-desc>.v-table__overflow {
      overflow-x: hidden !important;
      overflow-y: hidden !important;
      }

    .wrap-inv-description{
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden
    }
    .memo {
      padding: 15px 24px;
      font-size: 13px;
    }

</style>
